import { CommonData } from '../common_schema'

export const ddlData: CommonData[] = [
  {
    name: 'DDL Waiting Jobs Count',
    mean: 'DDL_waiting:total.values.mean',
    std: 'DDL_waiting:total.values.std',
    location: 'TiDB-Details --> DDL --> DDL Waiting Jobs Count'
  },
  {
    name: 'Batch Add Index Duration(for add_idx_rate)',
    mean: 'DDL_add_idx_rate:total.values.mean',
    std: 'DDL_add_idx_rate:total.values.std',
    location: 'TiDB-Details --> DDL --> Batch Add Index Duration 100'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
